// FilterOrg.jsx
import * as React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedOrg,
  setSelectedOrgName,
  clearSelectedOrg,
  clearResults,
} from "../../../../../features/OrgAdmin/orgAdminSlice";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { MenuItem, Paper, List } from "@mui/material";
import { fetchOrgs } from "../../../../../features/OrgAdmin/orgAdminThunk";

export default function FilterOrg() {
  const [org, setOrg] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const dispatch = useDispatch();
  const { results, loading, error, selectedOrgName } = useSelector((state) => state.org);


  const [searchTerm, setSearchTerm] = useState("");
  const wrapperRef = React.useRef(null);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTerm.trim() !== "") {
        dispatch(fetchOrgs(searchTerm));
        setShowDropdown(true);
      } else {
        dispatch(clearResults());
        dispatch(clearSelectedOrg());
        setShowDropdown(false);
      }
    }, 400); // 400ms delay

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  useEffect(() => {
  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

  // Sync input with selected org name
  useEffect(() => {
    setOrg(selectedOrgName);
  }, [selectedOrgName]);

  const handleChange = (event) => {
    const value = event.target.value;
    setOrg(value);
    setSearchTerm(value);

    if (value.trim() !== "") {
      dispatch(fetchOrgs(value));
      setShowDropdown(true);
    } else {
      dispatch(clearResults());
      dispatch(clearSelectedOrg());
      setShowDropdown(false);
    }
  };

  const handleSelect = (selectedItem) => {
    const orgName = selectedItem?.orgInfo?.orgName || "";
    setOrg(orgName);
    setShowDropdown(false);

    dispatch(setSelectedOrg(selectedItem));
    dispatch(setSelectedOrgName(orgName));
  };

  return (
    <MDBox display="flex" mb={4} gap="1rem" ml={9}>
      <MDBox display="flex" gap="1rem" sx={{ position: "relative" }} ref={wrapperRef}>
        <MDInput
          label="Select Org"
          value={org}
          onChange={handleChange}
          sx={{ minWidth: "50vw" }}
        />

        {showDropdown && org.trim().length > 0 && results.length > 0 && (
          <Paper
            elevation={3}
            sx={{
              position: "absolute",
              top: "100%",
              left: 0,
              width: "100%",
              zIndex: 10,
              maxHeight: 250,
              overflowY: "auto",
            }}
          >
            <List sx={{ p: 0 }}>
              {results.map((item, idx) => (
                <MenuItem
                  key={idx}
                  onClick={() => handleSelect(item)}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    px: 2,
                    py: 1.2,
                    borderBottom: "1px solid #eee",
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                    },
                  }}
                >
                  {/* LEFT: ORG NAME */}
                  <span style={{ fontWeight: 500, textTransform: "uppercase" }}>
                    {item?.orgInfo?.orgName}
                  </span>

                  {/* RIGHT: ADDRESS */}
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#666",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "50%",
                    }}
                  >
                    {item?.orgInfo?.address}
                  </span>
                </MenuItem>
              ))}
            </List>
          </Paper>
        )}

        {/* {loading && <MDTypography variant="caption">Loading...</MDTypography>} */}
        {error && <MDTypography variant="caption" color="error">{error}</MDTypography>}

        {/* Optional Debug */}
        {selectedOrgName && (
          <MDTypography variant="caption" color="success" sx={{ mt: 1 }}>
            Selected: {selectedOrgName}
          </MDTypography>
        )}
      </MDBox>
    </MDBox>
  );
}